// import { configureStore, combineReducers } from "@reduxjs/toolkit";
// import { persistReducer, persistStore } from "redux-persist";
// import storage from "redux-persist/lib/storage";
// import uiReducer from "./slice/matchesUiSlice";
// import activeTabReducer from "./slice/activeTabSlice";
// import tournamentsTabReducer from "./slice/tournamentsTabSlice";
// import createTournamentReducer from "./slice/createTournamentSlice";
// import selectedLeagueReducer from "./slice/selectedLeagueSlice";

// const rootReducer = combineReducers({
//   ui: uiReducer,
//   activeTab: activeTabReducer,
//    tournamentsTab: tournamentsTabReducer,
//    createTournament:createTournamentReducer,
//    selectedLeague: selectedLeagueReducer,
// });

// const persistConfig = {
//   key: "root",
//   storage,
//  whitelist: ['createTournament', 'selectedLeague'],
// blacklist: ["ui","activeTab","tournamentsTab"]
// };

// const persistedReducer = persistReducer(persistConfig, rootReducer);

// export const store = configureStore({
//   reducer: persistedReducer,
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: {
//         ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
//       },
//     }),
// });

// export const persistor = persistStore(store);

// // Types
// export type RootState = ReturnType<typeof rootReducer>;
// export type AppDispatch = typeof store.dispatch;



// store.ts
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistReducer, persistStore, createTransform } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import uiReducer from './slice/matchesUiSlice';
import activeTabReducer from './slice/activeTabSlice';
import tournamentsTabReducer from './slice/tournamentsTabSlice';
import createTournamentReducer from './slice/createTournamentSlice';
import selectedLeagueReducer from './slice/selectedLeagueSlice';
import authModalReducer from './slice/authModalSlice';
import userProfileReducer from './slice/playerProfileSlice';

/**
 * Strip large base64 image bytes from createTournament.draft before writing
 * to localStorage — they blow past the ~5 MB quota. The base64 is regenerated
 * from the user-selected file on demand and never needs to survive a reload.
 */
const stripCreateTournamentBase64 = createTransform(
  (inbound: { draft: Record<string, unknown> | null } | undefined) => {
    if (!inbound?.draft) return inbound;
    const { bannerBase64: _b, bannerFileType: _t, bannerFileName: _n, ...safeDraft } =
      inbound.draft as Record<string, unknown>;
    return { ...inbound, draft: safeDraft };
  },
  (outbound) => outbound,
);

// Persist only these two slices
const createTournamentPersistConfig = {
  key: 'createTournament',
  storage,
  transforms: [stripCreateTournamentBase64],
};
const selectedLeaguePersistConfig   = { key: 'selectedLeague', storage };
const selectedUserProfile = {key : 'userProfile', storage};

const rootReducer = combineReducers({
  ui: uiReducer,                    // not persisted
  activeTab: activeTabReducer,      // not persisted
  tournamentsTab: tournamentsTabReducer, // not persisted
  authModal: authModalReducer,      // not persisted

  //  persisted
  createTournament: persistReducer(createTournamentPersistConfig, createTournamentReducer),
  selectedLeague:   persistReducer(selectedLeaguePersistConfig,   selectedLeagueReducer),
  selectedProfile: persistReducer(selectedUserProfile, userProfileReducer),
});

const rootPersistConfig = {
  key: 'root',
  storage,
  // blacklist is technically optional now since only the wrapped slices persist,
  // but you can keep it for clarity:
  blacklist: ['ui', 'activeTab', 'tournamentsTab'],
};

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (gDM) =>
    gDM({
      serializableCheck: { ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'] },
    }),
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
